






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// tslint:disable-next-line:no-var-requires
const chartJs = require('chart.js');

@Component
export default class ChartComponent extends Vue {
    @Prop() private type!: string;
    @Prop() private data!: any;
    @Prop() private options!: any;

    private chart!: any;


    @Watch('data')
    private watchData(newValue: any, oldVal: any) {
        this.chart.data = newValue;
        this.chart.update();
    }

    private mounted() {
        this.initializeChart();
    }


    private initializeChart() {
        const chart = (this.$refs.chart as HTMLCanvasElement);
        chartJs.Chart.defaults.global.defaultFontFamily = 'Poppins';
        this.chart = new chartJs.Chart(chart, {
            type: this.type,
            data: this.data,
            options: this.options,
        });
    }
}
